module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_5012.40637b4d.png";